module.exports = __webpack_public_path__ + "static/img/icon17.5716658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon17.png
// module id = dEGM
// module chunks = 1